import Typography from "@material-ui/core/Typography";
import React from "react";
import TableContainer from "@material-ui/core/TableContainer";
import { Paper } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    anchortop: {
        display: "block",
        position: "relative",
        top: "-150px",
        visibility: "hidden",
    },
    anchor: {
        display: "block",
        position: "relative",
        top: "-90px",
        visibility: "hidden",
    },
});

export default function Scoreboard(props) {
    const classes = useStyles();

    let rounds = Object.keys(props.rounds).map((a) => parseInt(a)).sort((a, b) => a-b);

    return (
        <div>
            {rounds.length === 0 ? <Typography variant="subtitle1" component="h2">
                No rounds have taken place yet! Scoreboards will show up after the first round has completed.
            </Typography> : ""}
            {rounds.map((round) => {
                let rooms = Object.keys(props.rounds[round]).map((a) => parseInt(a)).sort((a, b) => a-b);
                return (
                    <div key={round} style={{textAlign: "left"}}>
                        <b>Round {round}</b>
                        {rooms.map((room) => {
                            let r = props.rounds[round][room.toString()];
                            let [team1, team2] = r.winner === r.team1.id ? [r.team1, r.team2] : [r.team2, r.team1];
                            let playerStats = new Array(Math.max(team1.players.length, team2.players.length));
                            for (let i = 0; i < playerStats.length; i++) {
                                playerStats[i] = {};
                            }
                            team1.players.forEach((player, i) => {
                                playerStats[i].player1 = player;
                            })
                            team2.players.forEach((player, i) => {
                                playerStats[i].player2 = player;
                            })

                            return (
                                <div key={`room${room}`} style={{margin: "20px 0px"}}>
                                    <div className={classes.anchor} id={`round${round}room${room}`} />
                                    {team1.name} {team1.score}, {team2.name} {team2.score}
                                    <TableContainer component={Paper} style={{margin: "20px 0px"}}>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow style={{backgroundColor: "#efefef"}}>
                                                    <TableCell><b>{team1.name}</b></TableCell>
                                                    <TableCell align="right"><b>TUH</b></TableCell>
                                                    <TableCell align="right"><b>15</b></TableCell>
                                                    <TableCell align="right"><b>10</b></TableCell>
                                                    <TableCell align="right"><b>-5</b></TableCell>
                                                    <TableCell align="right"><b>TOT</b></TableCell>
                                                    <TableCell><b>{team2.name}</b></TableCell>
                                                    <TableCell align="right"><b>TUH</b></TableCell>
                                                    <TableCell align="right"><b>15</b></TableCell>
                                                    <TableCell align="right"><b>10</b></TableCell>
                                                    <TableCell align="right"><b>-5</b></TableCell>
                                                    <TableCell align="right"><b>TOT</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {playerStats.map((players, i) => {
                                                    return ( <TableRow key={i}>
                                                            {players.player1 ? (
                                                                <React.Fragment>
                                                                    <TableCell>{players.player1.name}</TableCell>
                                                                    <TableCell
                                                                        align="right">{players.player1.tuh}</TableCell>
                                                                    <TableCell
                                                                        align="right">{players.player1.power}</TableCell>
                                                                    <TableCell
                                                                        align="right">{players.player1.ten}</TableCell>
                                                                    <TableCell
                                                                        align="right">{players.player1.neg}</TableCell>
                                                                    <TableCell
                                                                        align="right">{players.player1.power * 15 + players.player1.ten * 10 - players.player1.neg * 5}</TableCell>
                                                                </React.Fragment>
                                                            ) : (
                                                                <React.Fragment>
                                                                    <TableCell/>
                                                                    <TableCell align="right"/>
                                                                    <TableCell align="right"/>
                                                                    <TableCell align="right"/>
                                                                    <TableCell align="right"/>
                                                                    <TableCell align="right"/>
                                                                </React.Fragment>

                                                            )
                                                            }
                                                            {players.player2 ? (
                                                                <React.Fragment>
                                                                    <TableCell>{players.player2.name}</TableCell>
                                                                    <TableCell
                                                                        align="right">{players.player2.tuh}</TableCell>
                                                                    <TableCell
                                                                        align="right">{players.player2.power}</TableCell>
                                                                    <TableCell
                                                                        align="right">{players.player2.ten}</TableCell>
                                                                    <TableCell
                                                                        align="right">{players.player2.neg}</TableCell>
                                                                    <TableCell
                                                                        align="right">{players.player2.power * 15 + players.player2.ten * 10 - players.player2.neg * 5}</TableCell>
                                                                </React.Fragment>
                                                            ) : (
                                                                <React.Fragment>
                                                                    <TableCell/>
                                                                    <TableCell align="right"/>
                                                                    <TableCell align="right"/>
                                                                    <TableCell align="right"/>
                                                                    <TableCell align="right"/>
                                                                    <TableCell align="right"/>
                                                                </React.Fragment>

                                                            )
                                                            }
                                                    </TableRow>
                                                            )
                                                })}
                                                <TableRow style={{backgroundColor: "#ffece3"}}>
                                                    <TableCell>Total</TableCell>
                                                    <TableCell align="right">{team1.tuh}</TableCell>
                                                    <TableCell align="right">{team1.power}</TableCell>
                                                    <TableCell align="right">{team1.ten}</TableCell>
                                                    <TableCell align="right">{team1.neg}</TableCell>
                                                    <TableCell align="right">{team1.score - team1.bp}</TableCell>
                                                    <TableCell>Total</TableCell>
                                                    <TableCell align="right">{team2.tuh}</TableCell>
                                                    <TableCell align="right">{team2.power}</TableCell>
                                                    <TableCell align="right">{team2.ten}</TableCell>
                                                    <TableCell align="right">{team2.neg}</TableCell>
                                                    <TableCell align="right">{team2.score - team2.bp}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Typography variant="subtitle1" component="h2">
                                    Bonuses: {team1.name} {team1.bh} heard, {team1.bp} points, {team1.bh === 0 ? 0 : (team1.bp / team1.bh).toFixed(2)} PPB; {team2.name} {team2.bh} heard, {team2.bp} points, {team2.bh === 0 ? 0 : (team2.bp / team2.bh).toFixed(2)} PPB;
                                    </Typography>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
}
